import { render, staticRenderFns } from "./DegreeOfRusting.vue?vue&type=template&id=7f8fb9e4&"
import script from "./DegreeOfRusting.vue?vue&type=script&lang=js&"
export * from "./DegreeOfRusting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f8fb9e4')) {
      api.createRecord('7f8fb9e4', component.options)
    } else {
      api.reload('7f8fb9e4', component.options)
    }
    module.hot.accept("./DegreeOfRusting.vue?vue&type=template&id=7f8fb9e4&", function () {
      api.rerender('7f8fb9e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/customComponents/DegreeOfRusting.vue"
export default component.exports